<template lang="pug">
v-layout.pa-4(align-center justify-center)
  v-flex(class='forgot-password-form' class='text-xs-center')
    v-card.elevation-0(:color=" !$vuetify.theme.dark  ? 'white' : ''")
      v-card-text
        //- .text-center.py-4
        //-   h2 Cambiar contraseña
        v-alert(icon='info' dense text='' border="left"  type='info')
          span
            span.font-size-11 El cambio de la contraseña sera efectuado para el usuario:&nbsp;
            span.font-size-13.font-weight-700 {{$route.query.email}}
        v-form
          v-text-field(
            ref="password"
            v-model='newPassword'
            @keyup.enter="login"
            prepend-icon='lock'
            label='Ingrese nueva contraseña'
            :type="showPassword ? 'text' : 'password'"
            :append-icon="!showPassword ? 'visibility' : 'visibility_off'",
            @click:append='showPassword = !showPassword'
            )
          v-text-field(
            ref="password1"
            v-model='repeatNewPassword'
            @keyup.enter="login"
            prepend-icon='lock'
            label='Repetir nueva contraseña'
            :type="showPassword1 ? 'text' : 'password'"
            :append-icon="!showPassword1 ? 'visibility' : 'visibility_off'",
            @click:append='showPassword1 = !showPassword1'
            )
          v-btn(color="primary", @click="restablecer()" block ) Cambiar mi contraseña
    .d-flex.jc-center.ai-center
      small ¿Deseas iniciar sesión?
      v-btn.ml-2( small, color="secondary primary--text" @click="goTo('/login')") click aqui
</template>

<script>
import Router from '../router/not_logged.js'
import { apiPost, notify } from '../util/general'
export default {
  name: 'forgot-password-post-request',
  data () {
    return {
      newPassword      : '',
      repeatNewPassword: '',
      isLoading        : false,
      showPassword     : false,
      showPassword1    : false
    }
  },
  methods: {
    restablecer () {
      var vm            = this
      if (!vm.newPassword || !vm.repeatNewPassword) {
        notify(vm, 'error', 'Error', 'Ingrese la nueva contraseña dos veces')
        vm.$refs.password.focus()
        return
      }

      if (vm.newPassword !== vm.repeatNewPassword) {
        notify(vm, 'error', 'Error', 'Las contraseñas deben ser iguales')
        vm.$refs.password1.focus()
        return
      }
      vm.$store.dispatch('transaccion', {isProceso : true, message : 'actualizando contraseña'})
      var obj = {
        newPassword: vm.newPassword,
        email      : vm.$route.query.email,
        resetToken : vm.$route.query.resettoken
      }

      apiPost(vm, '/usuario/forgot-password-post', obj, function (data) {
        notify(vm, 'success', 'Contraseña cambiada con exito')
        // setTimeout(function () {
        //   window.location.href = '/login'
        // }, 500)
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    goTo (page) {
      Router.push(page)
    }
  }
}
</script>
<style lang="stylus" scoped>
.forgot-password-form
  max-width: 500px
</style>



// WEBPACK FOOTER //
// View_Forgot_Password_Post.vue?66e73072